export { createPageContextShared };
import { executeHookGenericGlobalCumulative } from './hooks/executeHookGeneric.js';
import { getPageConfigGlobalUserFriendly } from './page-configs/getPageConfigUserFriendly.js';
import { objectAssign } from './utils.js';
async function createPageContextShared(pageContextCreated, pageConfigGlobal) {
    const pageConfigGlobalUserFriendly = getPageConfigGlobalUserFriendly({
        pageConfigGlobalValues: pageConfigGlobal.configValues
    });
    objectAssign(pageContextCreated, {
        isPageContext: true,
        ...pageConfigGlobalUserFriendly
    }, true);
    await executeHookGenericGlobalCumulative('onCreatePageContext', pageConfigGlobal, pageContextCreated, pageContextCreated);
    return pageContextCreated;
}
